<template>
  <header class="blog-detail__header">
    <div class="blog-detail__info">
      <span v-if="strapiData?.PublicationDate">
        {{ $d(new Date(strapiData.PublicationDate), 'long') }}
      </span>

      <span
        v-if="strapiData?.ReadingTime"
        class="blog-detail__reading-time"
      >
        -
        <IconClock class="icon icon--clock" />
        {{ strapiData.ReadingTime }} {{ $t('minutes') }}
      </span>
    </div>

    <span
      v-if="strapiData?.Author?.Name && strapiData?.ParentPage?.PageTitle"
      class="blog-detail__author-name"
    >
      {{ strapiData.Author.Name }} in {{ strapiData.ParentPage.PageTitle }}
    </span>
  </header>
</template>

<script setup lang="ts">
defineProps<{
  strapiData: any
}>()
</script>

<style>
@import url("~layers/app/components/Blog/Header.css");
</style>
